import { Component, OnInit, Input, TemplateRef, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.css'],
  styles: ['td {border: 1px solid red;}']
})
export class DataGridComponent implements OnInit{

  _data: Array<any>;                                    //array of row items. the data to be displayed/edited
  @Input() set data(value: Array<any>){
    if(this.editing){
      this.cancel();
    }
    this._data = value;
    this.touchedData = JSON.parse(JSON.stringify(this._data));
    this.pageIndex = 0;
    this.refreshPage();
  }

  @Output() dataChange = new EventEmitter<any>();       //used for two way binding with parent component (page)
  @Output() itemChange = new EventEmitter<any>();       //used to emit a single item
  @Output() buttonEvent = new EventEmitter<any>();      //trigger on edit, add

  @Input() isValid: boolean = true;                     //two way binding for validation
  @Output() isValidChange = new EventEmitter<any>();    

  @Input() formTemplate: TemplateRef<HTMLElement>;            //reference to the child ng-template where the form is defined
  @Input() viewTemplate: TemplateRef<HTMLElement>;            //reference to the child ng-template where the view elements (td's) are defined
  @Input() footerTemplate: TemplateRef<HTMLElement> = null;   //reference to the child ng-template for the table footer
  @Input() headerTemplate: TemplateRef<HTMLElement> = null;   //reference to the child ng-template for the table footer

  @Input() objectBluePrint: any = {}                    //JSON for the default object.                                      STANDARD JSON: {'key1': {'key2': 'value' }} --> BLUEPRINT INPUT: {'key1': {}}
  @Input() set overwriteEditedItem(item: any){          //setting this value in the parent will add new keys and values if the keys are not present, and update associated values if they are
    if(this.editIndex !=-1){
      const keys = Object.keys(item);
      for(const key of keys){
        this.pageArray[this.editIndex][key] = item[key];
      }
    }else{
      console.log('no row being edited');
    }
  }

  @Input() set itemsPerPage(value: number){            //number of elements to show on one page, default 20
    this._itemsPerPage = value;
    this.pageIndex = 0;
    this.refreshPage();
  }                 
  @Input() columnNames: Array<string>;                  //Defines the header for each column
  @Input() spacing: Array<number>;                      //Defines the width of each column, including the buttons.          spacing="[ int, int, int, int]"
  @Input() debug: boolean = false;                      //show hide component JSON
  @Input() allowDelete: boolean = true;
  @Input() allowEdit: boolean = true;
  @Input() allowAdd: boolean = true;
  @Input() severAdd: boolean = false;
  @Input() customButtons: any = {}                         //{'button1Text' : 'button1Code' , ...} 
  @Input() deleteMessage: string = "Are you sure you want to permanently delete this item?";

  _itemsPerPage: number = 20;
  pageIndex: number = 0;      
  currentPage: number = 1;
  totalPages: number = 1;      
  mouseIndex: number = -1;
  editIndex: number = -1;
  touchedData: Array<any>;
  pageArray: Array<any>;
  bodyWidth: string;
  editing: boolean = false;

  constructor() { }

  ngOnInit() {
    this.touchedData = JSON.parse(JSON.stringify(this._data));
    this.pageIndex = 0;
    this.calculateSpacing();
    this.refreshPage();
    this.editing = false;
  }

  //takes the spacing array and calculates a width % for each column
  calculateSpacing(){
    var total = 0;
    var bodyTotal = 0;
    //calculate total and bodyTotal
    for(var i = 0; i < this.spacing.length; i++){
      total += this.spacing[i];
      if(i == this.spacing.length - 2){
        bodyTotal = total;
      }
    }
    //set bodyWidth
    this.bodyWidth = String(bodyTotal / total * 100.0) + "%";
    if(this.debug){
      console.log("bodyWidth: ", this.bodyWidth);
    }
    //set columnWidth
    var columnWidth = [];
    for(i = 0; i < this.spacing.length; i++){
      columnWidth.push(String(this.spacing[i] / total * 100.0) + "%");
    }
    this.spacing = JSON.parse(JSON.stringify(columnWidth));
  }

  setMouseOver(index: number){
    this.mouseIndex = index;
  }

  editRow(index: number){
    this.isValid = false;
    this.buttonEvent.emit('edit');
    this.isValidChange.emit(this.isValid);
    this.editing = true;
    this.editIndex = index;
  }

  deleteRow(index: number){
    this.buttonEvent.emit('delete');
    if(confirm(this.deleteMessage)){
      //!!emit item before delete!!
      this.itemChange.emit({action: 'delete', item: this.touchedData[this.pageIndex + index]});
      console.log(this.touchedData[this.pageIndex + index]);
      this.touchedData.splice(this.pageIndex + index, 1);
      this.updateLocalData();

      //on empty page (such as after delete operation), navigate to the last page
      if((this.pageArray.length == 0 && this._data.length != 0) && !(this._itemsPerPage > this._data.length)){
        this.pageIndex = this._data.length - this._itemsPerPage;
        this.refreshPage();
      }
    }
  }

  saveChanges(){
    this.buttonEvent.emit('save')
    var temp = this.editIndex
    this.updateLocalData();
    this.itemChange.emit({action: 'put', item: this.pageArray[temp]});
  }

  //emits data obj so parent can 
  updateLocalData(){
    this._data = JSON.parse(JSON.stringify(this.touchedData));
    if(this.debug){console.log(this._data);};
    this.dataChange.emit(this._data);
    this.refreshPage();
    this.editing = false;
  }

  //abort edit
  cancel(){
    this.touchedData = JSON.parse(JSON.stringify(this._data));
    this.refreshPage();
    this.editing = false;
  }

  //create a new row at page index 0
  addRow(){
    if(!this.editing && !this.severAdd){
      this.isValid = false;
      this.isValidChange.emit(this.isValid);
      this.editing = true;
      this.pageIndex = 0;
      this.touchedData.splice(0, 0, JSON.parse(JSON.stringify(this.objectBluePrint)));
      this.refreshPage();
      this.editIndex = 0;
    }
  }

  //page navigation
  forward(num: number){
    num *= this._itemsPerPage;
    this.cancel();
    this.pageIndex += num;
    if(this.pageIndex >= this._data.length){
      this.pageIndex -= num;
    }
    this.refreshPage();
  }
  
  //page navigation
  back(num: number){
    num *= this._itemsPerPage;
    this.cancel();
    this.pageIndex -= num;
    if(this.pageIndex < 0){
      this.pageIndex = 0;
    }
    this.refreshPage();
  }

  //reset the pageArray
  refreshPage(){
    this.editIndex = -1;
    this.pageArray = this.touchedData.slice(this.pageIndex, this.pageIndex + this._itemsPerPage);
    this.calculatePages();
  }

  calculatePages(){
    this.totalPages = Math.ceil(this._data.length / this._itemsPerPage);
    this.currentPage = this.pageIndex / this._itemsPerPage + 1;
  }

}
